// import React from "react";
// import Snackbar from "@mui/material/Snackbar";
// import IconButton from "@mui/material/IconButton";
// import Icon from "@mui/material/Icon";

// export default class Snackbar1 extends React.PureComponent {
//   render() {
//     const { snackbar } = this.props;

//     return (
//       <Snackbar
//         anchorOrigin={{
//           vertical: "bottom",
//           horizontal: "center",
//         }}
//         open={snackbar.response_received}
//         autoHideDuration={3000}
//         onClose={() => {
//           this.props.closeSnackBar();
//         }}
//         ContentProps={{
//           "aria-describedby": "message-id",
//         }}
//         message={<span id="message-id">{snackbar.message}</span>}
//         action={[
//           <IconButton
//             key="close"
//             aria-label="Close"
//             color="inherit"
//             onClick={() => {
//               this.props.closeSnackBar();
//             }}
//             size="large"
//           >
//             <Icon>close</Icon>
//           </IconButton>,
//         ]}
//       />
//     );
//   }
// }
 
// import React from "react";
// import Snackbar from "@mui/material/Snackbar";
// import Alert from "@mui/material/Alert";
// import IconButton from "@mui/material/IconButton";
// import Icon from "@mui/material/Icon";
// import WarningAmberIcon from '@mui/icons-material/WarningAmber';
// import CheckIcon from '@mui/icons-material/Check';
 

// export default class Snackbar1 extends React.PureComponent {
//   render() {
//     const { snackbar } = this.props;
//     console.log("snackbar data",snackbar)
  
//     return (
//       <Snackbar
//         anchorOrigin={{
//           vertical: "bottom",
//           horizontal: "center",
//         }}
//         open={snackbar.response_received}
//         autoHideDuration={3000}
//         onClose={() => {
//           this.props.closeSnackBar();
//         }}
//         sx={{
//           "& .MuiPaper-root": {  // Target the Paper component that wraps Alert
//             width: "910px",
//             minHeight: "52px",
//             borderRadius: "8px",
//             border: snackbar.messageType==="success" ? "1px solid #32A05F" : "1px solid #C45446",
//             gap: "8px",
//             padding: "8px 12px",  
//           }
//         }}
//       >
//         <Alert
//         //  icon={<IconComponent fontSize="inherit" />}
//           onClose={() => {
//             this.props.closeSnackBar();
//           }}
//           severity={ snackbar.messageType==="success"  ? "success" : "warning"}
//           icon={ snackbar.messageType==="success" ? <CheckIcon /> : <WarningAmberIcon  sx={{
//             color:'#C45446', 
//             backgroundColor: '#F9EEED', 
//             borderRadius: '50%', 
            
//           }}/>}
//           sx={{ 
//             width: "100%",
//             height: "100%",
//             backgroundColor:  snackbar.messageType==="success"  ? "#EBF6EF" : "#F9EEED", 
//             padding: 0, // Remove default Alert padding
//             alignItems: "center", // Center content vertically
//             '& .MuiAlert-message': {
//               width: "100%",
//               padding: 0, // Remove default message padding
//             },
//             '& .MuiAlert-action': {
//               paddingLeft: "8px", // Add gap between message and action
//               marginRight: 0,
//             }
//           }}
//           action={
//             <IconButton
//               aria-label="close"
//               color="inherit"
//               size="small"
//               onClick={() => {
//                 this.props.closeSnackBar();
//               }}
//               sx={{
//                 marginLeft: "auto", // Push close button to the right
//               }}
//             >
//               <Icon fontSize="small">close</Icon>
//             </IconButton>
//           }
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     );
//   }
// }
import React from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import CheckIcon from '@mui/icons-material/Check';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'; // <-- Import info icon


// Define a configuration object for different message types
const messageTypeConfig = {
  success: {
    icon: <CheckIcon />,
    borderColor: "#32A05F",
    backgroundColor: "#EBF6EF",
    iconColor: "#32A05F",
    iconBackground: "#EBF6EF",
    severity: "success"
  },
  error: {
    icon: <WarningAmberIcon />,
    borderColor: "#C45446",
    backgroundColor: "#F9EEED",
    iconColor: "#C45446",
    iconBackground: "#F9EEED",
    severity: "warning" // Material-UI uses "warning" for error-like states
  },
  
    info: {
    icon: <InfoOutlinedIcon />, // <-- Info icon
    borderColor: "#2196F3",      // Blue tone
    backgroundColor: "#E3F2FD",  // Light blue
    iconColor: "#2196F3",        // Primary blue
    iconBackground: "#E3F2FD",
    severity: "info"
  }
};

export default class Snackbar1 extends React.PureComponent {
  render() {
    const { snackbar } = this.props;
    const config = messageTypeConfig[snackbar.messageType] || messageTypeConfig.error;

    return (
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        open={snackbar.response_received}
        autoHideDuration={3000}
        onClose={() => {
          this.props.closeSnackBar();
        }}
        sx={{
          "& .MuiPaper-root": {
            width: "910px",
            minHeight: "52px",
            borderRadius: "8px",
            border: `1px solid ${config.borderColor}`,
            gap: "8px",
            padding: "8px 12px",  
          }
        }}
      >
        <Alert
          onClose={() => {
            this.props.closeSnackBar();
          }}
          severity={config.severity}
          icon={React.cloneElement(config.icon, {
            sx: {
              color: config.iconColor,
              backgroundColor: config.iconBackground,
              borderRadius: '50%',
              padding: '4px'
            }
          })}
          sx={{ 
            width: "100%",
            height: "100%",
            backgroundColor: config.backgroundColor, 
            padding: 0,
            alignItems: "center",
            '& .MuiAlert-message': {
              width: "100%",
              padding: 0,
            },
            '& .MuiAlert-action': {
              paddingLeft: "8px",
              marginRight: 0,
            }
          }}
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                this.props.closeSnackBar();
              }}
              sx={{
                marginLeft: "auto",
                color: config.iconColor
              }}
            >
              <Icon fontSize="small">close</Icon>
            </IconButton>
          }
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    );
  }
}